import * as utility from "../lib/AuthorUtility";
import UniqueItem from "./UniqueItem";
import * as catalogUtility from "../lib/CatalogLinkUtilities";
import * as UrlUtilities from '../lib/UrlUtilities';

class SeriesTitle extends UniqueItem {
	constructor(titleJson) {
		super(titleJson);
		this.title = titleJson.full_title;
		this.volumeNumber = titleJson.volume;
		this.author = utility.formatAuthorName(titleJson.author);
		this.bookJacket = UrlUtilities.useLocalProtocol(titleJson.bookjacket_url);
		this.reason = titleJson.reason;
		this.catalogLink = titleJson.is_held_locally === false ? null : catalogUtility.getTitleCatalogLink(titleJson.links);
	}
}

export default SeriesTitle;



// WEBPACK FOOTER //
// ./src/models/SeriesTitle.js